var React = require('react');

function Section (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M958 931H2V2H1594V931H1455","stroke":"white","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M1457 930V797L1418.66 845.014V926.427L1360.83 838.285L1337.14 868.576V928H1324.27V882.33L1288.91 927.907L1269.09 928L1342.5 833.699H1300.49L1231.69 919.715V863.324H1195.69V928H1167.63L1167.66 913.342H1123.54V894.089H1152.97L1177.33 864.12H1088.73V928H1075.86V864.172H1041.05V928H1038.42L988.821 864.172L956 821.934V930","stroke":"white","strokeWidth":"4","strokeMiterlimit":"10","key":1})]);
}

Section.defaultProps = {"width":"100%","height":"934","viewBox":"0 0 1596 934","fill":"none","preserveAspectRatio":"none"};

module.exports = Section;

Section.default = Section;
